import React from 'react';

type Props = {
    link: string;
    img: string;
    title: string;
    description: string;
    date: string;
};

const MaterialsCard = (props: Props) => {
    const { link, img, title, description, date } = props;
    return (
        <a className="page-materials-card__link" href={link}>
            <div className="page-materials-card__img">
                <img src={img} alt={title} />
            </div>
            <h4 className="page-materials-card__title _default">{title}</h4>
            <span className="page-materials-card__date _default">
                {date}
            </span>
            <p className="page-materials-card__text">{description}</p>
        </a>
    );
};

export default MaterialsCard;
